var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[244],"data-type":_vm.dataType,"field-code":"public-transportation","graph-id":68,"title":"(공중교통수단) 중대재해 발생 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }